import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

// Components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import SidebarUser from "components/Sidebar/SidebarUser";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// Views
import TransaksiJurnal from "views/admin/transaction/transaksiJurnal/TransaksiJurnal";
import TransaksiKeluar from "views/admin/transaction/transaksiKeluar/TransaksiKeluar";
import TransaksiMasuk from "views/admin/transaction/transaksiMasuk/TransaksiMasuk";

import TransaksiJurnalAkuntan from "views/akuntan/transaction/transaksiJurnal/TransaksiJurnalAkuntan";
import TransaksiKeluarAkuntan from "views/akuntan/transaction/transaksiKeluar/TransaksiKeluarAkuntan";
import TransaksiMasukAkuntan from "views/akuntan/transaction/transaksiMasuk/TransaksiMasukAkuntan";

export default function Transaction() {
  const userLogin = useSelector((state) => state.global.userLogin);

  if (userLogin.role === "adminSistem") {
    return (
      <>
        <Sidebar />
        <div className="relative md:ml-64 bg-blueRay-100">
          <AdminNavbar />
          {/* Header */}
          <HeaderStats />
          <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
            <Switch>
              <Route
                path="/transaction/transaksiMasuk"
                exact
                component={TransaksiMasuk}
              />
              <Route
                path="/transaction/transaksiKeluar"
                exact
                component={TransaksiKeluar}
              />
              <Route
                path="/transaction/transaksiJurnal"
                exact
                component={TransaksiJurnal}
              />
              <Redirect
                from="/transaction/*"
                to="/transaction/transaksiMasuk"
              />
            </Switch>
            <FooterAdmin />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SidebarUser />
      <div className="relative md:ml-64 bg-blueRay-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
          <Switch>
            <Route
              path="/transaction/transaksiMasuk"
              exact
              component={TransaksiMasukAkuntan}
            />
            <Route
              path="/transaction/transaksiKeluar"
              exact
              component={TransaksiKeluarAkuntan}
            />
            <Route
              path="/transaction/transaksiJurnal"
              exact
              component={TransaksiJurnalAkuntan}
            />
            <Redirect from="/transaction/*" to="/transaction/transaksiMasuk" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
